<div class="bar-top">
    <div class="menu-btn-container" *ngIf="isLoggedIn"><button class="menu-btn focus-element" (click)="toggleNavBar()"><span class="focus--content" tabindex="-1"><span class="burger-lines"></span></span></button></div>
    <div class="menu-btn-container" *ngIf="!isLoggedIn"></div>
    <img src="/images/switch2-logo.png" alt="Switch2 logo" class="logo">
    <div class="client-dropdown" *ngIf="showClientSelect">
        <label for="client">Client</label>
        <select name="client" id="" class="select__standalone" [formControl]="form.controls['clientId']">
            <option [value]="client.clientId" *ngFor="let client of clients">{{client.clientName}}</option>
        </select>
    </div>
</div>
